import { render } from "./dot-divider.vue?vue&type=template&id=6fab07ae"
import script from "./dot-divider.vue?vue&type=script&lang=js"
export * from "./dot-divider.vue?vue&type=script&lang=js"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
